// src/web/routes/_authenticated.tsx
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { QueryBoundary } from '@/components/ErrorBoundary'
import { Shell } from '@/components/layout/Shell'
import { api } from '@/lib/api'
import { queryKeys } from '@/lib/query'

export const Route = createFileRoute('/_authenticated')({
	beforeLoad: async ({ context }) => {
		try {
			await context.queryClient.ensureQueryData({
				queryKey: queryKeys.auth.me,
				queryFn: async () => {
					const { data, error, status } = await api.api.auth.me.get()
					if (error || !data?.user) {
						throw new Error(status === 403 ? 'NO_DAM_ACCESS' : 'UNAUTHORIZED')
					}
					return data.user
				},
				staleTime: 1000 * 60 * 5,
			})
		} catch (error) {
			if (error instanceof Error && error.message === 'NO_DAM_ACCESS') {
				throw redirect({ to: '/no-access' })
			}
			throw redirect({ to: '/login' })
		}
	},
	component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
	return (
		<Shell>
			<QueryBoundary>
				<Outlet />
			</QueryBoundary>
		</Shell>
	)
}
